<nz-modal
  [(nzVisible)]="visible"
  [nzTitle]="modalTitle"
  [nzFooter]="modalFooter"
  (nzOnCancel)="close()"
  [nzWidth]="1000"
>
  <ng-template #modalTitle>
    <app-modal-title icon="cloud-upload" title="Subir Documentos" />
  </ng-template>

  <div *nzModalContent>
    <nz-spin [nzSpinning]="loading">
      <div class="grid grid-cols-3 gap-4">
        @for (col of columns; track col) {
          <div class="space-y-4">
            @for (docType of getTypesByColumn(col); track docType.id) {
              <div
                class="upload-slot"
                [class.upload-slot--loaded]="getSlot(docType.id).fileName"
                [class.upload-slot--uploading]="getSlot(docType.id).uploading"
                (click)="fileInput.click()"
              >
                <input
                  #fileInput
                  type="file"
                  [accept]="docType.accept"
                  (change)="onFileSelected($event, docType)"
                  hidden
                />

                @if (getSlot(docType.id).uploading) {
                  <div class="slot-content">
                    <span nz-icon nzType="loading" class="slot-icon slot-icon--uploading"></span>
                    <span class="slot-label">Subiendo...</span>
                    <span class="slot-hint">{{ getSlot(docType.id).fileName }}</span>
                  </div>
                } @else if (getSlot(docType.id).fileName) {
                  <div class="slot-content">
                    <span nz-icon nzType="check-circle" class="slot-icon slot-icon--success"></span>
                    <span class="slot-label slot-label--success">¡Archivo cargado!</span>
                    <span class="slot-hint">{{ getSlot(docType.id).fileName }}</span>
                    <div class="slot-actions">
                      @if (getSlot(docType.id).kiddocumento) {
                        <button
                          nz-button
                          nzType="link"
                          nzSize="small"
                          nz-tooltip
                          nzTooltipTitle="Ver documento"
                          [nzLoading]="getSlot(docType.id).viewing"
                          (click)="viewFile($event, docType)"
                        >
                          @if (!getSlot(docType.id).viewing) {
                            <span nz-icon nzType="eye"></span>
                          }
                        </button>
                      }
                      <!-- El (click) solo corta la propagación: sin esto el
                           click burbujea al contenedor de la tarjeta y abre el
                           file picker. El borrado lo dispara (nzOnConfirm).
                           Sin nz-tooltip: se solaparía con el popconfirm. -->
                      <button
                        nz-button
                        nzType="link"
                        nzSize="small"
                        nzDanger
                        nz-popconfirm
                        [nzPopconfirmTitle]="'¿Eliminar ' + docType.label + '?'"
                        nzPopconfirmPlacement="top"
                        nzOkText="Eliminar"
                        nzCancelText="Cancelar"
                        nzOkDanger
                        [attr.aria-label]="'Eliminar ' + docType.label"
                        [disabled]="getSlot(docType.id).viewing"
                        (click)="$event.stopPropagation()"
                        (nzOnConfirm)="deleteFile(docType)"
                      >
                        <span nz-icon nzType="delete"></span>
                      </button>
                    </div>
                  </div>
                } @else {
                  <div class="slot-content">
                    <span nz-icon nzType="upload" class="slot-icon slot-icon--upload"></span>
                    <span class="slot-label">{{ docType.label }}</span>
                    <span class="slot-hint">{{ docType.hint }}</span>
                  </div>
                }
              </div>
            }
          </div>
        }
      </div>
    </nz-spin>
  </div>

  <ng-template #modalFooter>
    <p class="upload-footer-tip">
      Formatos permitidos: PDF, JPG, PNG, XLS, XLSX.<br />
      Tamaño máximo: 5MB
    </p>
  </ng-template>
</nz-modal>
